import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { StudentAccount } from '@df/interfaces';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'app-student-info',
    templateUrl: './student-info.component.html',
    styleUrls: ['./student-info.component.scss']
})
export class StudentInfoComponent implements OnInit, OnDestroy {
    @Input() studentAccount: StudentAccount;
    @Input() studentIndex: number;
    @Input() cameFromLesson: boolean = false;
    @Input() lessonData: { subject: number; lesson: number };

    amount: number;

    private destroy$ = new Subject<boolean>();

    constructor(private router: Router) {}

    public ngOnInit(): void {
        this.amount = +this.studentAccount.amount;
    }

    public setGender(): string {
        if (this.studentAccount) {
            return this.studentAccount.student.gender === 'f' ? 'female' : 'male';
        } else {
            return 'male';
        }
    }

    public goToLesson(): void {
        this.router.navigate(
            [
                'teacher/teach',
                this.studentAccount.student.student_class,
                this.lessonData.subject,
                'progress',
                this.lessonData.lesson
            ],
            {
                queryParams: {
                    student: this.studentIndex
                }
            }
        );
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
